import { Action, createReducer, on } from '@ngrx/store';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState,
    updateRecord,
    updateRecordSuccess,
    updateRecordFailure
} from './failed-emails.action';

import { FailedEmails } from './failed-emails.model';

export interface FailedEmailsRecordsState {
    listData: any[];
    total: number;
    singleData: FailedEmails;
    loading: boolean;
    updation: boolean;
    error: any;
}

export const initialState: FailedEmailsRecordsState = {
    listData: [],
    total: 0,
    singleData: null,
    loading: false,
    updation: false,
    error: null,
};


export const FailedEmailsRecordReducer = createReducer(

    initialState,

    // Fetch Data
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),


    on(updateRecord, (state) => {
        return { ...state, updation: false, error: null };
    }),
    on(updateRecordSuccess, (state) => {
        return { ...state, updation: true };
    }),
    on(updateRecordFailure, (state, { error }) => {
        return { ...state, error, updation: false };
    }),
    

    on(resetState, () => initialState)  // Reset action handler
);